'use client';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import EfIcon from '../ef-icon';
import gtm from '@/utils/gtm';
import './index.scss';

const ICON = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="84" height="50" viewBox="0 0 84 50" fill="none">
        <g opacity="0.83" filter="url(#filter0_f_1188_7143)">
            <path
                d="M57.1895 62.3257C41.0688 51.1794 32.2017 36.0673 37.3843 28.5718C42.5669 21.0763 59.8366 24.0358 75.9573 35.1821C92.0781 46.3284 100.945 61.4406 95.7626 68.9361C90.58 76.4316 73.3102 73.472 57.1895 62.3257Z"
                fill="url(#paint0_linear_1188_7143)"
            />
        </g>
        <defs>
            <filter
                id="filter0_f_1188_7143"
                x="0.204296"
                y="-11.2698"
                width="132.738"
                height="120.047"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="17.85" result="effect1_foregroundBlur_1188_7143" />
            </filter>
            <linearGradient id="paint0_linear_1188_7143" x1="80.0072" y1="63.0277" x2="61.877" y2="26.1858" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FF5C00" />
                <stop offset="0.485974" stopColor="#FF7777" />
                <stop offset="1" stopColor="#FFC83A" />
            </linearGradient>
        </defs>
    </svg>
);
const ICON_CLOSE = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
        <circle cx="7.50001" cy="7.50001" r="7.50001" fill="black" fillOpacity="0.4" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.89039 5.64775C10.1101 5.42808 10.1101 5.07192 9.89039 4.85225C9.67072 4.63258 9.31457 4.63258 9.0949 4.85225L7.37155 6.5756L5.6482 4.85225C5.42853 4.63258 5.07238 4.63258 4.85271 4.85225C4.63304 5.07192 4.63304 5.42808 4.85271 5.64775L6.57605 7.3711L4.85225 9.0949C4.63258 9.31457 4.63258 9.67072 4.85225 9.89039C5.07192 10.1101 5.42808 10.1101 5.64775 9.89039L7.37155 8.16659L9.09535 9.89039C9.31502 10.1101 9.67118 10.1101 9.89085 9.89039C10.1105 9.67072 10.1105 9.31457 9.89085 9.0949L8.16704 7.3711L9.89039 5.64775Z"
            fill="white"
        />
    </svg>
);

export interface EfBarLeftProps {
    /**
     * 多少秒后显示(单位秒)
     */
    isShowTimes?: number;
    /**
     * 跳转链接
     */
    href?: string;
    /**
     * 点击回调
     */
    callback?: () => void;
    /**
     * 所有分辨率展示的图片链接
     */
    pc: string;
    /**
     * 标题
     */
    title: string;
    /**
     * 描述
     */
    desc: string;
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护:谢保林
 *
 * 图标容器
 *
 * 左侧bar条
 */
export default function EfBarLeft({ isShowTimes, className, href, callback, pc, title, desc }: EfBarLeftProps) {
    const prefixCls = 'ef-bar-left';
    const [isShow, setIsShow] = useState(false);
    const compCls = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-show`]: isShow,
    });
    // 点击
    const clickHandle = () => {
        callback && callback();
        gtm.push({
            event: 'uaEvent',
            event_name: 'floating_button',
            button_name: title || 'IMG',
        });
    };

    const onClose = () => setIsShow(false);

    useEffect(() => {
        if (isShowTimes) {
            setTimeout(() => {
                setIsShow(true);
            }, isShowTimes * 1000);
        } else {
            setIsShow(true);
        }
    }, []);

    return (
        <a href={href} className={compCls}>
            <div className="close" onClick={onClose}>
                <ICON_CLOSE />
            </div>
            <div className="wrapper" onClick={clickHandle}>
                <EfIcon pc={pc} className={`${prefixCls}-img`} />
                <ICON />
                <div className={`${prefixCls}-msg`}>
                    {title && <div className={`${prefixCls}-title`}>{title}</div>}
                    {desc && <div className={`${prefixCls}-desc`}>{desc}</div>}
                </div>
            </div>
        </a>
    );
}
